export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_02_poweredge-end.e9750b04.jpg";